/* stylelint-disable selector-class-pattern */

.overlaySpinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.previewItem {
  position: relative;
  display: flex;
  justify-content: center;
  cursor: pointer;

  img {
    display: block;
    width: var(--img-size, 90px);
    height: var(--img-size, 90px);
    border: 1px solid var(--x-color-background-darker);
  }
}

// !isCleaned && !ignoreCleaned branch.

.notCleaned {
  img {
    border-color: var(--x-color-text-red);
  }
}

// isSelected branch. The `> span` rule keeps !important verbatim.

.selected {
  > div {
    border-color: var(--x-color-action);
  }

  > span {
    /* stylelint-disable-next-line declaration-no-important */
    border-color: var(--x-color-action) !important;
  }
}

// NotCleaned (a <span> badge). width = var(--img-size, 90px)
// reproduces the emotion `${imgSize || size}`.

.notCleanedBadge {
  position: absolute;
  display: block;
  width: var(--img-size, 90px);
  margin: 0 auto;
  background-color: var(--x-color-text-red);
  color: var(--x-color-text-white);
  font-size: 10px;
  text-align: center;
}

// PreviewDiv. imgSize present → horizontal spacing; absent → vertical.

.previewDiv {
  text-align: center;
  text-transform: none;

  > div:not(:last-of-type) {
    margin-bottom: 5px;
  }

  &.hasImgSize {
    > div:not(:last-of-type) {
      margin-right: 5px;
      margin-bottom: 0;
    }
  }
}

.divImg {
  display: flex;
  width: var(--img-size, 90px);
  min-width: var(--img-size, 90px);
  height: var(--img-size, 90px);
  min-height: var(--img-size, 90px);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--x-color-border);
  border-radius: 2px;
  background-color: var(--x-color-background-white);

  // imgSize-only sub-rule (emotion applied .no-preview-text hide ONLY when
  // imgSize truthy).

  &.hasImgSize {
    .no-preview-text {
      display: none;
    }
  }

  svg {
    font-size: 35px;
  }
}

.previewShowMore {
  display: flex;
  width: var(--img-size, 90px);
  height: var(--img-size, 90px);
  align-items: center;
  justify-content: center;
  border: 1px solid var(--x-color-background-darker);
  margin: auto;

  // imgSize-only sub-rule (emotion applied button font-size ONLY when imgSize
  // truthy).

  &.hasImgSize {
    button {
      font-size: 10px;
    }
  }
}
